<template>
    <div class="tim_cont_r">
        <van-nav-bar title="订单记录" placeholder fixed>
            <template #left >
                <van-icon @click="goback" name="arrow-left" size="22" color="#000" />
            </template>
        </van-nav-bar>
        <div class="tit">
            <el-date-picker size="small" :clearable="false" :editable="false" v-model="queryParams.month_date"
                type="month" placeholder="选择月" @change="changeMonth" value-format="yyyy-MM">
            </el-date-picker>
        </div>
        <div style="height: 50px;"></div>
        <div v-if="orderlist.length != 0">
            <div class="orderlist" v-infinite-scroll="load" infinite-scroll-immediate="false">
                <div class="items" v-for="(item, index) in orderlist" :key="index">
                    <div class="itime">{{ item.createtime | formatDate }}</div>
                    <div class="item_flex">
                        <img src="@/assets/user/u1.png" alt="" srcset="">
                        <div class="uflex">
                            <div class="cflex">
                                <div class="r1">
                                    <div v-if="item.order_status == 1 && item.refund_status == 1">订单待支付</div>
                                    <div v-else-if="item.order_status == 2">订单待确认</div>
                                    <div v-else-if="item.order_status == 3">订单处理中</div>
                                    <div v-else-if="item.order_status == 4">订单已生效</div>
                                    <div v-else-if="item.order_status == 5 && item.refund_status == 1">已取消</div>
                                    <div v-else-if="item.order_status != 0 && item.refund_status == 2">退款中</div>
                                    <div v-else-if="item.order_status != 0 && item.refund_status == 3">已退款</div>
                                </div>
                                <div class="price">￥{{ item.order_money }}</div>
                            </div>
                            <div class="r2">订单编号：{{ item.order_no }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="kongts" v-if="orderlist.length == 0">
            <div>
                <img src="@/assets/user/k.png" alt="" srcset="">
                <div class="texts">暂无订单</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserOrderList } from '@/api/index'
export default {
    name: '',
    data() {
        return {
            orderlist: [],
            queryParams: {
                page: 1,
                limit: 10,
                month_date: '',
                supplier_user_id: '',
                status: ''
            },
        }
    },
    mounted() {
        this.queryParams.supplier_user_id = this.$route.query.id
        this.queryParams.month_date = this.getGurrentTime()
        this.getlist()
    },
    methods: {
        getGurrentTime() {
            let yy = new Date().getFullYear();
            let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
            return yy + '-' + mm
        },
        getlist() {
            getUserOrderList(this.queryParams).then(res => {
                if (res.code == 1) {
                    this.orderlist.push(...res.data.list)
                    let total = Math.ceil(res.data.total / this.queryParams.limit);
                    this.nolist = total == 0
                }
            })
        },
        goback() {
            this.$router.go(-1)
        },
        load() {
            this.queryParams.page++
            this.getlist()
        },
        changeMonth(e) {
            this.queryParams.month_date = e
            this.orderlist = []
            this.queryParams.page = 1
            this.getlist()
        },
    },
}
</script>
<style lang='scss' scoped>
.kongts {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 700px;
    text-align: center;

    img {
        width: 42px;
        height: 42px;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        line-height: 46px;
    }

}

.tim_cont_r {
    .tit {
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding: 0px 10px;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;
        position: fixed;
        background: #fff;
    }

    .orderlist {
        height: calc(100vh - 100px);
        overflow: auto;

        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }

        // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
        &::-webkit-scrollbar-thumb {
            background: rgba(144, 147, 153, 0.3);
            cursor: pointer;
            border-radius: 4px;
        }

        .items {
            padding: 12px 10px;
            box-sizing: border-box;

            .itime {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #ADAAAA;
                margin-bottom: 6px;
            }

            .item_flex {
                display: flex;

                img {
                    width: 36px;
                    height: 36px;
                }

                .uflex {
                    flex: 1;
                    margin-left: 6px;

                    .cflex {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 3px;
                    }

                    .r1 {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        color: #000000;
                    }

                    .r2 {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 12px;
                        color: #ADAAAA;
                    }
                }

                .price {
                    font-family: PingFang SC, PingFang SC;
                    font-weight: bold;
                    font-size: 14px;
                    color: #000000;
                }
            }
        }
    }
}
</style>